/**
 * Canonical share URL for a memorial profile page.
 * Uses memorial.slug (clean, no spaces) + MongoDB id.
 */
export function getMemorialShareUrl(memorial, memorialId, origin) {
  const base = origin || (typeof window !== "undefined" ? window.location.origin : "");
  const id = memorialId || memorial?._id;
  const slug = memorial?.slug || memorial?.webAddress || "memorial";
  return `${base}/profile/${slug}/${id}`;
}

export function formatShareUrlForDisplay(url) {
  return url.replace(/^https?:\/\//, "");
}
